import Player1 from '../Images/Player1.webp';
import Player2 from '../Images/Player2.webp';
import Player4 from '../Images/Player4.webp';
import Player5 from '../Images/Player5.webp';
import Player6 from '../Images/Player6.webp';
import Player7 from '../Images/Player7.webp';
import Player8 from '../Images/Player8.webp';
import Player9 from '../Images/Player9.webp';
import Player11 from '../Images/Player11.webp';
import Player12 from '../Images/Player12.webp';
import Player13 from '../Images/Player13.webp';
import Player14 from '../Images/Player14.webp';
import Player16 from '../Images/Player16.jpg';
import Player17 from '../Images/Player17.jpg';
import Player20 from '../Images/Player20.webp';

export const players = [
  {
    id: 1,
    name: 'Ashish Manger',
    position: 'Goalkeeper',
    number: 1,
    image: Player1
  },
  {
    id: 2,
    name: 'Abishek Chhetri',
    position: 'Defender',
    number: 2,
    image: Player2
  },
  {
    id: 3,
    name: 'Jiwan Rai',
    position: 'Midfielder',
    number: 4,
    image: Player4
  },
  {
    id: 4,
    name: 'Samir Bhattarai',
    position: 'Defender',
    number: 5,
    image: Player5
  },
  {
    id: 5,
    name: 'Unmol Chhetri',
    position: 'Midfielder',
    number: 6,
    image: Player6
  },
  {
    id: 6,
    name: 'Sajan Chhetri',
    position: 'Forward',
    number: 7,
    image: Player7
  },
  {
    id: 7,
    name: 'Roman Rai',
    position: 'Midfielder',
    number: 8,
    image: Player8
  },
  {
    id: 8,
    name: 'Bibeak Rai',
    position: 'Forward',
    number: 9,
    image: Player9
  },
  {
    id: 9,
    name: 'Bhim Chhetri',
    position: 'Forward',
    number: 11,
    image: Player11
  },
  {
    id: 10,
    name: 'Bishal Chhetri',
    position: 'Midfielder',
    number: 12,
    image: Player12
  },
  {
    id: 11,
    name: 'Dhan Rai',
    position: 'Defender',
    number: 13,
    image: Player13
  },
  {
    id: 12,
    name: 'Bebash Gurung',
    position: 'Defender',
    number: 14,
    image: Player14
  },
  {
    id: 13,
    name: 'Sabin Rai',
    position: 'Defender',
    number: 16,
    image: Player16
  },
  {
    id: 14,
    name: 'Algesh Pradhan',
    position: 'Midfielder',
    number: 17,
    image: Player17
  },
  {
    id: 15,
    name: 'Bhu Whan',
    position: 'Midfielder',
    number: 20,
    image: Player20
  },
];
